export const SCHEDULE_TERMINAL_BALANCE_TOLERANCE = 1.00;

export const getTerminalBalance = (schedule) => {
  if (!Array.isArray(schedule) || schedule.length === 0) return null;
  const v = Number(schedule[schedule.length - 1]?.outstanding_balance);
  return Number.isFinite(v) ? v : null;
};

export const isTerminalBalanceZero = (schedule) => {
  const b = getTerminalBalance(schedule);
  return b !== null && Math.abs(b) <= SCHEDULE_TERMINAL_BALANCE_TOLERANCE;
};

export const isRunningBalanceZero = (runningBalances) => {
  if (!Array.isArray(runningBalances) || runningBalances.length === 0) return false;
  const last = Number(runningBalances[runningBalances.length - 1]);
  if (!Number.isFinite(last)) return false;
  return Math.abs(last) <= SCHEDULE_TERMINAL_BALANCE_TOLERANCE;
};
